export const NOTIFICATION_DATE_FORMAT = 'd MMM HH:mm';
export const NOTIFICATION_DATE_FORMAT_WITH_YEAR = 'd MMM HH:mm, yyyy';
export const NOTIFICATIONS_PER_PAGE = 10;
